import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { HiBars3, HiChevronDown, HiXMark } from "react-icons/hi2";
import logo from "../assets/logo-orange.svg";
const NAV_ITEMS = [
  { title: "\xDCber uns", link: "/about" },
  {
    title: "Resort",
    link: "/hiru-villa",
    subLinks: [
      { title: "Hiru Villa", link: "/hiru-villa" },
      { title: "Hiru Om", link: "/hiru-om" },
      { title: "Hiru Mudra", link: "/hiru-mudra" },
      { title: "Hiru Aadya", link: "/hiru-aadya" }
    ]
  },
  { title: "Preispl\xE4ne", link: "/pricing" },
  {
    title: "Ayurveda",
    link: "/ayurveda/interesting-facts",
    subLinks: [
      { title: "Interessante Fakten", link: "/ayurveda/interesting-facts" },
      { title: "Panchakarma", link: "/ayurveda/panchakarma" },
      { title: "Ayurveda-Ern\xE4hrung", link: "/ayurveda/food" },
      { title: "Spirituelle Reise", link: "/ayurveda/spiritual-journey" }
    ]
  },
  { title: "Aktivit\xE4ten", link: "/activities" },
  { title: "Touren", link: "/tours" },
  { title: "Kontakt", link: "/contact-us" }
];
const isNavLinkActive = (pathname, link) => {
  if (link === "/") {
    return pathname === "/";
  }
  if (pathname === link) {
    return true;
  }
  return pathname.startsWith(`${link}/`);
};
const NavBar = () => {
  const navLabels = {
    email: "E-Mail",
    whatsApp: "WhatsApp",
    location: "Standort",
    facebook: "Facebook",
    instagram: "Instagram",
    openMenu: "Men\xFC \xF6ffnen",
    closeMenu: "Men\xFC schlie\xDFen",
    closeMenuOverlay: "Men\xFC schlie\xDFen",
    toggleSubmenu: "Untermen\xFC umschalten",
    bookNow: "Jetzt buchen"
  };
  const pathname = useLocation().pathname;
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [openDesktopDropdown, setOpenDesktopDropdown] = useState(null);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 8);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = isMobileNavOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileNavOpen]);
  useEffect(() => {
    setIsMobileNavOpen(false);
    setOpenDesktopDropdown(null);
    setOpenMobileDropdown(null);
  }, [pathname]);
  return <header
    className={`fixed z-50 w-full overflow-x-clip transition-all duration-300
        ${isScrolled ? "border-b-0 bg-transparent backdrop-blur-none md:border-b md:border-amber-100/90 md:bg-white/95 md:shadow-lg md:shadow-amber-100/70 md:backdrop-blur" : "border-b-0 bg-transparent backdrop-blur-none"}
      `}
  >
    {
      /* Desktop Navbar */
    }
    <div className={`mx-auto hidden w-full max-w-[90rem] items-center px-4 py-4 xl:flex lg:px-6 lg:py-5 xl:px-8 xl:py-6 ${isScrolled ? "justify-center" : "justify-between"}`}>
      {
        /* Brand */
      }
      <div className={`flex shrink-0 items-center gap-2 lg:gap-3 ${isScrolled ? "md:hidden" : ""}`}>
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="Hiru Ayurveda Resorts"
            className="h-auto w-[110px] lg:w-[170px] xl:w-[160px]" loading="eager" fetchPriority="high" />
        </Link>
      </div>

      {
        /* Nav Links */
      }
      <nav className={`mx-3 flex flex-1 items-center justify-center gap-0 lg:mx-4 lg:gap-0.5 ${isScrolled ? "md:flex-none" : ""}`}>
        {NAV_ITEMS.map((item) => {
          const isActive = isNavLinkActive(pathname, item.link);
          if (item.subLinks?.length) {
            const hasActiveSubItem = item.subLinks.some(
              (subItem) => isNavLinkActive(pathname, subItem.link)
            );
            const isDesktopDropdownOpen = openDesktopDropdown === item.link;
            return <div
              key={item.link}
              className="relative"
              onMouseEnter={() => setOpenDesktopDropdown(item.link)}
              onMouseLeave={() => setOpenDesktopDropdown(null)}
            >
              <Link
                to={item.link}
                className={`font-serif flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-3 text-sm tracking-wide transition-colors duration-200 after:absolute after:bottom-0 after:left-2 after:right-2 after:h-[2px] after:origin-center after:rounded-full after:bg-orange after:transition-transform after:duration-200 after:content-[''] md:px-4 md:py-3 md:text-base lg:px-4 lg:text-base xl:px-2 xl:text-sm ${isScrolled ? "text-white hover:text-white md:text-black md:hover:text-black" : "text-white hover:text-white"} ${isActive || hasActiveSubItem ? "after:scale-x-100" : "after:scale-x-0 hover:after:scale-x-100"}`}
                style={{ fontWeight: 600 }}
              >
                {item.title}
                <HiChevronDown className={`h-4 w-4 transition-transform duration-200 ${isDesktopDropdownOpen ? "rotate-180" : ""}`} />
              </Link>

              <div className={`absolute left-0 top-full z-20 min-w-[220px] rounded-xl border p-2 transition-all duration-200 ${isDesktopDropdownOpen ? "visible translate-y-0 opacity-100" : "invisible translate-y-2 opacity-0 pointer-events-none"} ${isScrolled ? "border-amber-100 bg-[#F28600] shadow-xl shadow-amber-100/50 md:border-slate-200 md:bg-[#F28600] md:shadow-lg md:shadow-slate-200/60" : "border-amber-100 bg-[#F28600] shadow-xl shadow-amber-100/50"}`}>
                {item.subLinks.map((subItem) => {
                  const isSubActive = isNavLinkActive(pathname, subItem.link);
                  return <Link
                    key={subItem.link}
                    to={subItem.link}
                    onClick={() => setOpenDesktopDropdown(null)}
                    className={`block rounded-lg px-3 py-2 text-sm font-semibold transition-colors relative
                            ${isScrolled ? "text-white hover:text-amber-300 md:text-black md:hover:text-black" : "text-white hover:text-amber-300"}
                            ${isSubActive ? "after:absolute after:left-3 after:right-3 after:bottom-1 after:h-[2px]  after:rounded-full after:content-[''] after:scale-x-100" : "after:scale-x-0 hover:after:scale-x-100"}
                          `}
                    style={{ textDecoration: isSubActive ? "underline" : "none", textUnderlineOffset: isSubActive ? 4 : void 0, background: "none" }}
                  >
                    {subItem.title}
                  </Link>;
                })}
              </div>
            </div>;
          }
          return <Link
            key={item.link}
            to={item.link}
            className={`font-serif relative whitespace-nowrap rounded-md px-3 py-3 text-sm tracking-wide transition-colors duration-200 after:absolute after:bottom-0 after:left-2 after:right-2 after:h-[2px] after:origin-center after:rounded-full after:bg-orange after:transition-transform after:duration-200 after:content-[''] md:px-4 md:py-3 md:text-base lg:px-4 lg:text-base xl:px-2 xl:text-sm ${isScrolled ? "text-white hover:text-white md:text-black md:hover:text-black" : "text-white hover:text-white"} ${isActive ? "after:scale-x-100" : "after:scale-x-0 hover:after:scale-x-100"}`}
            style={{ fontWeight: 600 }}
          >
            {item.title}
          </Link>;
        })}
      </nav>

      {
        /* Social Icons + Language */
      }
      <div className="ml-2 flex shrink-0 flex-col items-end justify-center gap-3 lg:gap-4">
        <div className="hidden items-center gap-3 lg:gap-4 xl:gap-1.5 xl:flex">
          <a
            href="mailto:info@hiru-ayurveda-resorts.com"
            aria-label={navLabels.email}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-amber-200 bg-white text-black shadow-sm transition-all duration-200 hover:border-[#244B0C] hover:bg-[#244B0C] hover:text-white lg:h-11 lg:w-11"
          >
            <MdEmail className="h-4 w-4" />
          </a>

          <a
            href="https://wa.me/94767744180"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={navLabels.whatsApp}
            className="flex h-8 w-8 items-center justify-center rounded-full border border-amber-200 bg-white text-black transition-all hover:border-[#25D366] hover:bg-[#25D366] hover:text-white lg:h-9 lg:w-9"
          >
            <FaWhatsapp className="h-4 w-4" />
          </a>

          <a
            href="https://maps.app.goo.gl/fAocAzqfYBbMk6Gc8"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={navLabels.location}
            className="flex h-8 w-8 items-center justify-center rounded-full border border-amber-200 bg-white text-black transition-all hover:border-[#EA4335] hover:bg-[#EA4335] hover:text-white lg:h-9 lg:w-9"
          >
            <MdLocationOn className="h-4 w-4" />
          </a>

          <a
            href="https://www.facebook.com/ayurvedasrilanka"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={navLabels.facebook}
            className="flex h-8 w-8 items-center justify-center rounded-full border border-amber-200 bg-white text-black transition-all hover:border-[#1877F2] hover:bg-[#1877F2] hover:text-white lg:h-9 lg:w-9"
          >
            <FaFacebook className="h-4 w-4" />
          </a>

          <a
            href="https://www.instagram.com/hiru_resorts/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={navLabels.instagram}
            className="flex h-8 w-8 items-center justify-center rounded-full border border-amber-200 bg-white text-black transition-all hover:border-[#E1306C] hover:bg-[#E1306C] hover:text-white lg:h-9 lg:w-9"
          >
            <FaInstagram className="h-4 w-4" />
          </a>

        </div>

        <Link
          to="/search"
          className="mt-4 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-[#1f4d3c] px-5 py-3 text-sm font-bold tracking-wide text-white shadow-lg transition-all duration-200 hover:bg-[#c4a868] hover:text-black lg:px-6 lg:py-3 lg:text-base"
        >
          {navLabels.bookNow}
        </Link>
      </div>
    </div>

    {
      /* Mobile Header */
    }
    <div
      className={`grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center px-4 py-2 transition-all duration-300 xl:hidden ${isScrolled ? "bg-white shadow-md backdrop-blur" : "bg-transparent"}`}
    >
      <div className="min-w-0 justify-self-start" />

      <Link to="/" className="flex items-center justify-center">
        <img
          src={logo}
          alt="Garden Beach Ayurveda Resort"
          className="h-auto w-[120px] sm:w-[120px]" loading="eager" fetchPriority="high" />
      </Link>

      <div className="flex flex-col items-end gap-1">
        <Link
          to="/search"
          className="whitespace-nowrap rounded-full bg-[#1f4d3c] px-1.5 py-1 text-[9px] font-bold tracking-wide text-white transition-all hover:bg-[#c4a868] hover:text-black sm:px-3 sm:py-1.5 sm:text-xs"
        >
          {navLabels.bookNow}
        </Link>
        <button
          onClick={() => setIsMobileNavOpen((prev) => !prev)}
          aria-label={isMobileNavOpen ? navLabels.closeMenu : navLabels.openMenu}
          className={isScrolled ? "text-gray-900" : "text-white"}
        >
          {isMobileNavOpen ? <HiXMark className={`h-7 w-7 ${isScrolled ? "text-gray-900" : "text-white"}`} /> : <HiBars3 className={`h-7 w-7 ${isScrolled ? "text-gray-900" : "text-white"}`} />}
        </button>
      </div>
    </div>

    {
      /* Mobile Drawer */
    }
    <div
      className={`fixed inset-0 z-[60] xl:hidden ${isMobileNavOpen ? "pointer-events-auto visible" : "pointer-events-none invisible"}`}
    >
      <button
        className={`absolute inset-0 bg-black/35 transition-opacity duration-300 ${isMobileNavOpen ? "opacity-100" : "opacity-0"}`}
        aria-label={navLabels.closeMenuOverlay}
        onClick={() => setIsMobileNavOpen(false)}
      />

      <div
        className={`absolute right-0 top-0 flex h-[100dvh] w-[90%] max-w-sm flex-col overflow-y-auto overscroll-contain bg-gradient-to-b from-white to-amber-50 shadow-2xl transition-transform duration-300 ease-out ${isMobileNavOpen ? "translate-x-0" : "translate-x-[105%]"}`}
      >
        {
          /* Drawer Header */
        }
        <div className="sticky top-0 z-10 flex items-center justify-between border-b-2 border-amber-100 bg-white px-4 py-4 shadow-md">
          <Link to="/" onClick={() => setIsMobileNavOpen(false)} className="flex items-center">
            <img
              src={logo}
              alt="Garden Beach Ayurveda Resort"
              className="h-auto w-[80px]" loading="lazy" />
          </Link>

          <button
            onClick={() => setIsMobileNavOpen(false)}
            aria-label={navLabels.closeMenu}
            className="rounded-lg p-1.5 text-black transition-colors hover:bg-amber-100"
          >
            <HiXMark className="h-7 w-7 text-black" />
          </button>
        </div>

        {
          /* Mobile Links */
        }
        <nav className="flex flex-col px-3 py-3">
          {NAV_ITEMS.map((item) => {
            const isActive = isNavLinkActive(pathname, item.link);
            const hasActiveSubItem = item.subLinks?.some((subItem) => isNavLinkActive(pathname, subItem.link)) ?? false;
            if (item.subLinks?.length) {
              const isOpen = openMobileDropdown === item.link;
              return <div key={item.link}>
                <div className="flex items-center justify-between gap-2 rounded-lg px-2 py-3.5 hover:bg-amber-50 transition-colors">
                  <Link
                    to={item.link}
                    onClick={() => setIsMobileNavOpen(false)}
                    className={`font-serif text-left text-lg tracking-wide transition-colors duration-200 sm:text-xl ${isActive || hasActiveSubItem ? "text-[#1f4d3c]" : "text-gray-800"}`}
                    style={{ fontWeight: 600 }}
                  >
                    {item.title}
                  </Link>

                  <button
                    onClick={() => setOpenMobileDropdown(
                      (prev) => prev === item.link ? null : item.link
                    )}
                    className="rounded-md p-1.5 text-gray-600 transition-colors hover:text-[#1f4d3c] hover:bg-white"
                    aria-expanded={isOpen}
                    aria-label={`${navLabels.toggleSubmenu}: ${item.title}`}
                  >
                    <HiChevronDown
                      className={`h-5 w-5 transition-transform duration-200 ${isOpen ? "rotate-180 text-[#1f4d3c]" : ""}`}
                    />
                  </button>
                </div>

                <div
                  className={`grid overflow-hidden transition-all duration-300 ${isOpen ? "grid-rows-[1fr] pb-2" : "grid-rows-[0fr]"}`}
                >
                  <div className="min-h-0 space-y-0.5 pl-4">
                    {item.subLinks.map((subItem) => {
                      const isSubActive = isNavLinkActive(pathname, subItem.link);
                      return <Link
                        key={subItem.link}
                        to={subItem.link}
                        onClick={() => setIsMobileNavOpen(false)}
                        className={`block rounded-md px-3 py-2 text-sm font-semibold transition-colors ${isSubActive ? "bg-[#1f4d3c] text-white" : "text-gray-700 hover:bg-amber-100 hover:text-[#1f4d3c]"}`}
                      >
                        {subItem.title}
                      </Link>;
                    })}
                  </div>
                </div>
              </div>;
            }
            return <Link
              key={item.link}
              to={item.link}
              onClick={() => setIsMobileNavOpen(false)}
              className={`font-serif relative rounded-lg px-2 py-3.5 text-lg tracking-wide transition-colors duration-200 sm:text-xl hover:bg-amber-50 ${isActive ? "text-[#1f4d3c] bg-amber-50" : "text-gray-800"}`}
              style={{ fontWeight: 600 }}
            >
              {item.title}
            </Link>;
          })}
        </nav>

        {
          /* Mobile Social Icons */
        }
        <div className="flex flex-row gap-2 px-4 pt-4 pb-2 justify-center items-center mt-2">
          <a
            href="mailto:info@hiru-ayurveda-resorts.com"
            aria-label={navLabels.email}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-black transition-all hover:border-[#EA4335] hover:bg-[#EA4335] hover:text-white sm:h-11 sm:w-11"
          >
            <MdEmail className="h-4 w-4 sm:h-5 sm:w-5" />
          </a>

          <a
            href="https://wa.me/94767744180"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={navLabels.whatsApp}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-black transition-all hover:border-[#25D366] hover:bg-[#25D366] hover:text-white sm:h-11 sm:w-11"
          >
            <FaWhatsapp className="h-4 w-4 sm:h-5 sm:w-5" />
          </a>

          <a
            href="https://maps.app.goo.gl/fAocAzqfYBbMk6Gc8"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={navLabels.location}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-black transition-all hover:border-[#EA4335] hover:bg-[#EA4335] hover:text-white sm:h-11 sm:w-11"
          >
            <MdLocationOn className="h-4 w-4 sm:h-5 sm:w-5" />
          </a>

          <a
            href="https://www.facebook.com/ayurvedasrilanka"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={navLabels.facebook}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-black transition-all hover:border-[#1877F2] hover:bg-[#1877F2] hover:text-white sm:h-11 sm:w-11"
          >
            <FaFacebook className="h-4 w-4 sm:h-5 sm:w-5" />
          </a>

          <a
            href="https://www.instagram.com/hiru_resorts/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={navLabels.instagram}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 text-black transition-all hover:border-[#E1306C] hover:bg-[#E1306C] hover:text-white sm:h-11 sm:w-11"
          >
            <FaInstagram className="h-4 w-4 sm:h-5 sm:w-5" />
          </a>

        </div>

        <div className="sticky bottom-0 mt-4 border-t-2 border-amber-100 bg-gradient-to-b from-white to-amber-50 px-4 py-4 backdrop-blur shadow-xl">
          <Link
            to="/search"
            onClick={() => setIsMobileNavOpen(false)}
            className="block w-full rounded-xl bg-[#1f4d3c] px-4 py-3 text-center text-sm font-bold tracking-wide text-white transition-colors hover:bg-[#c4a868] hover:text-black shadow-md"
          >
            {navLabels.bookNow}
          </Link>
        </div>
      </div>
    </div>
  </header>;
};
export default NavBar;
